

































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Form } from 'element-ui';
import * as amplitude from 'amplitude-js';
import {
  ClientInfoDTOGenderEnum,
  ClientInfoDTO,
  ClientInfoDTOStatusEnum,
  ClientInfoDTOCategoryEnum,
} from '@/api';
import EditingLayout from '@/layouts/EditingLayout.vue';
import { clientsModule } from '@/store';
import services from '@/services';

const emptyForm: ClientInfoDTO = {
  firstName: '',
  surname: '',
  stylistId: undefined,
  category: ClientInfoDTOCategoryEnum.MASS,
  status: ClientInfoDTOStatusEnum.NEW,
  phoneNumber: '',
  email: '',
  gender: ClientInfoDTOGenderEnum.WOMAN,
  styleComments: '',
  bodyComments: '',
  cashBack: undefined,
  size: {
    top: '',
    bottom: '',
    shoes: '',
    jeans: '',
    neck: '',
  },
  body: {
    height: undefined,
    chest: undefined,
    waist: undefined,
    hips: undefined,
  },
  jobDetails: '',
  clientRequest: '',
  preferredStores: '',
  preferences: '',
  restrictions: '',
  stylistNotes: '',
  sourceFromInfo: '',
};

@Component({
  name: 'client-edit-page',
  components: {
    EditingLayout,
  },
})
export default class Catalog extends Vue {
  form = emptyForm;

  statuses: {[key: string]: string} = {};

  loading = false;

  created() {
    clientsModule.fetchStylists();
    if (this.$route.params.clientId) {
      this.loading = true;
      clientsModule.fetchClient(Number(this.$route.params.clientId))
        .finally(() => {
          this.loading = false;
        });
      this.form = { ...emptyForm, ...clientsModule.model };
      amplitude.getInstance().logEvent('Open client form', { clientId: this.$route.params.clientId });
    } else {
      amplitude.getInstance().logEvent('New client form');
    }
    services.clientsService().clientEndpointStatusList()
      .then(r => r.data)
      .then((statuses) => {
        this.statuses = statuses;
      });
  }

  get client() {
    return clientsModule.model;
  }

  get stylists() {
    return clientsModule.stylists;
  }

  get categories() {
    return Object.values(ClientInfoDTOCategoryEnum);
  }

  @Watch('form.gender')
  genderChange() {
    if (this.form.size && (this.form.gender === ClientInfoDTOGenderEnum.WOMAN)) {
      this.form.size.neck = '';
    }
  }

  onSubmit() {
    (this.$refs.form as Form).validate((valid) => {
      if (valid) {
        clientsModule.saveClient(this.form)
          .then((id) => {
            this.$router.push({ name: 'client-page', params: { clientId: String(id) } });
          })
          .catch((e) => {
            // eslint-disable-next-line no-console
            console.error('Ошибка с сервера', e);
            this.$notify({ title: 'Ошибка! Обратитесь к администратору', message: e, type: 'error' });
          });
      } else {
        // eslint-disable-next-line no-console
        console.error('Форма заполнена не корректно');
        this.$notify({ title: 'Форма заполнена не корректно', message: 'Пожалуйста, проверьте поля формы', type: 'error' });
      }
    });
  }

  onClose() {
    if (this.$route.params.clientId) {
      this.$router.push({ name: 'client-page', params: { clientId: this.$route.params.clientId } });
    } else {
      this.$router.push({ name: 'clients' });
    }
  }
}
